var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnselectConvenients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 2.75H18.25V12.5C18.25 15.1234 16.1234 17.25 13.5 17.25H8.5C5.87665 17.25 3.75 15.1234 3.75 12.5V2.75ZM5.25 4.25V12.5C5.25 14.2949 6.70507 15.75 8.5 15.75H13.5C15.2949 15.75 16.75 14.2949 16.75 12.5V4.25H5.25Z",
    fill: "#282D4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4.25H18.25V2.75H20C21.2426 2.75 22.25 3.75736 22.25 5V8C22.25 9.24264 21.2426 10.25 20 10.25H18.25V8.75H20C20.4142 8.75 20.75 8.41421 20.75 8V5C20.75 4.58579 20.4142 4.25 20 4.25Z",
    fill: "#282D4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 20.75H2V19.25H20V20.75Z",
    fill: "#282D4B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectConvenients);
export default __webpack_public_path__ + "static/media/unselect_convenients.9de576bd29d17b447054dc7dca9fdaa0.svg";
export { ForwardRef as ReactComponent };